import { render, staticRenderFns } from "./calendar-detail.vue?vue&type=template&id=272d473b&scoped=true"
import script from "./calendar-detail.vue?vue&type=script&lang=js"
export * from "./calendar-detail.vue?vue&type=script&lang=js"
import style0 from "./calendar-detail.vue?vue&type=style&index=0&id=272d473b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d473b",
  null
  
)

export default component.exports